module.exports = __webpack_public_path__ + "img/express.950e8f7c.jpg";